import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { getLangMsg, getCompLangMsg } from '../locale';
var defaultConfig = {
  getPrefixCls: function getPrefixCls(configPrefixCls, suffixCls, customizePrefixCls) {
    var _context;

    // 获取样式前缀方法
    if (customizePrefixCls) return customizePrefixCls;
    configPrefixCls = configPrefixCls || 'kd';
    var t = suffixCls ? _concatInstanceProperty(_context = "".concat(configPrefixCls, "-")).call(_context, suffixCls) : configPrefixCls;
    return t;
  },
  prefixCls: 'kd',
  locale: {
    getLangMsg: getLangMsg,
    getCompLangMsg: getCompLangMsg
  }
};
export default defaultConfig;